/**
 * @generated SignedSource<<1ad8c5def28bde63785d07d489f4a4b3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SourcingReviewKeyInputObject = {
  entityType: string;
  qboId: string;
};
export type reviewQueuePage_ActionMutation$variables = {
  action: string;
  bankAccountId?: string | null | undefined;
  bankTxnId?: string | null | undefined;
  counterparty?: string | null | undefined;
  counterpartyPattern?: string | null | undefined;
  expectedState?: string | null | undefined;
  items?: ReadonlyArray<SourcingReviewKeyInputObject> | null | undefined;
  periodEnd?: string | null | undefined;
  periodStart?: string | null | undefined;
  runId?: string | null | undefined;
};
export type reviewQueuePage_ActionMutation$data = {
  readonly sourcingReviewAction: {
    readonly affectedCount: number;
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly job: {
      readonly jobId: number;
      readonly status: string;
    } | null | undefined;
    readonly ok: boolean;
    readonly preview: {
      readonly count: number;
      readonly counted: number;
      readonly countedSumCents: number;
      readonly sumCents: number;
      readonly uncounted: number;
      readonly uncountedSumCents: number;
    } | null | undefined;
  } | null | undefined;
};
export type reviewQueuePage_ActionMutation = {
  response: reviewQueuePage_ActionMutation$data;
  variables: reviewQueuePage_ActionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "action"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "bankAccountId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "bankTxnId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "counterparty"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "counterpartyPattern"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "expectedState"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "items"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "periodEnd"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "periodStart"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "runId"
},
v10 = [
  {
    "kind": "Variable",
    "name": "action",
    "variableName": "action"
  },
  {
    "kind": "Variable",
    "name": "bankAccountId",
    "variableName": "bankAccountId"
  },
  {
    "kind": "Variable",
    "name": "bankTxnId",
    "variableName": "bankTxnId"
  },
  {
    "kind": "Variable",
    "name": "counterparty",
    "variableName": "counterparty"
  },
  {
    "kind": "Variable",
    "name": "counterpartyPattern",
    "variableName": "counterpartyPattern"
  },
  {
    "kind": "Variable",
    "name": "expectedState",
    "variableName": "expectedState"
  },
  {
    "kind": "Variable",
    "name": "items",
    "variableName": "items"
  },
  {
    "kind": "Variable",
    "name": "periodEnd",
    "variableName": "periodEnd"
  },
  {
    "kind": "Variable",
    "name": "periodStart",
    "variableName": "periodStart"
  },
  {
    "kind": "Variable",
    "name": "runId",
    "variableName": "runId"
  }
],
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ok",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "affectedCount",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "AccountJob",
  "kind": "LinkedField",
  "name": "job",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "jobId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "SourcingReviewPreview",
  "kind": "LinkedField",
  "name": "preview",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "count",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sumCents",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "counted",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "countedSumCents",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "uncounted",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "uncountedSumCents",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "reviewQueuePage_ActionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v10/*: any*/),
        "concreteType": "SourcingReviewActionMutationPayload",
        "kind": "LinkedField",
        "name": "sourcingReviewAction",
        "plural": false,
        "selections": [
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v15/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v6/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v1/*: any*/),
      (v8/*: any*/),
      (v7/*: any*/),
      (v2/*: any*/),
      (v9/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Operation",
    "name": "reviewQueuePage_ActionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v10/*: any*/),
        "concreteType": "SourcingReviewActionMutationPayload",
        "kind": "LinkedField",
        "name": "sourcingReviewAction",
        "plural": false,
        "selections": [
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v15/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b62d1d3b715130f568746835be3a7f86",
    "id": null,
    "metadata": {},
    "name": "reviewQueuePage_ActionMutation",
    "operationKind": "mutation",
    "text": "mutation reviewQueuePage_ActionMutation(\n  $action: String!\n  $items: [SourcingReviewKeyInputObject!]\n  $counterparty: String\n  $counterpartyPattern: String\n  $bankAccountId: ID\n  $periodStart: String\n  $periodEnd: String\n  $bankTxnId: ID\n  $runId: ID\n  $expectedState: String\n) {\n  sourcingReviewAction(action: $action, items: $items, counterparty: $counterparty, counterpartyPattern: $counterpartyPattern, bankAccountId: $bankAccountId, periodStart: $periodStart, periodEnd: $periodEnd, bankTxnId: $bankTxnId, runId: $runId, expectedState: $expectedState) {\n    ok\n    affectedCount\n    job {\n      jobId\n      status\n    }\n    preview {\n      count\n      sumCents\n      counted\n      countedSumCents\n      uncounted\n      uncountedSumCents\n    }\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "64b367ebc67500c0270cd8e71ad6df13";

export default node;
